import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

const style = StyleSheet.create({
  container: {
      padding: 20,
  },
})

const Results = ({ navigation }) => {

  return (
    <View style={style.container}>
      <Text>Results</Text>
    </View>
  )

}

export default Results; 